import { btnSecondary, colors } from './styles'

interface PaginationProps {
  readonly page: number
  readonly total: number
  readonly limit: number
  readonly onPageChange: (page: number) => void
}

export function Pagination({ page, total, limit, onPageChange }: PaginationProps) {
  const totalPages = Math.ceil(total / limit)
  if (totalPages <= 1) return null

  return (
    <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' }}>
      <button
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        style={{ ...btnSecondary, opacity: page <= 1 ? 0.5 : 1 }}
      >
        Prev
      </button>
      <span style={{ padding: '0.5rem', color: colors.textMuted, fontSize: '0.875rem' }}>
        Page {page} of {totalPages}
      </span>
      <button
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        style={{ ...btnSecondary, opacity: page >= totalPages ? 0.5 : 1 }}
      >
        Next
      </button>
    </div>
  )
}
